export type QuoteStatsAttributes = {
    newCount: number,
    newAmount: string,
    draftCount: number,
    draftAmount: string,
    proposedCount: number,
    proposedAmount: string,
    preApprovedCount: number,
    preApprovedAmount: string,
}

export type QuoteStatsDto = {
    id: string
    type: string
    attributes: QuoteStatsAttributes
}

export default class QuoteStats {
    private dto: QuoteStatsDto

    constructor(dto: QuoteStatsDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "quote-stats"
    }

    getId(): string {
        return this.dto.id
    }

    getAttributes(): QuoteStatsAttributes {
        return this.dto.attributes
    }
}


// WEBPACK FOOTER //
// ./src/state/stats/QuoteStats.ts